import {
  IAdvancedRulesClient,
  IAdvancedRulesServer,
  IForm,
} from "@common/redux/formBuilder/interface";
import {
  IAddNewFormAction,
  IAddNewFormActionPayload,
  IFetchFormsByIdsAction,
  IFetchFormsAction,
  IFetchFormsActionPayload,
  IFormServer,
  ITransformAndUpdateFormAction,
  IFetchFormsSuccessActionPayload,
  IDuplicateFormAction,
  IDuplicateFormFailureAction,
  IDuplicateFormSuccessAction,
  IUpdateFormAction,
  IDeleteFormRulesActionPayload,
  IDeleteFormRulesAction,
  IFetchFormRulesAction,
  IUpdateFormRuleAction,
  IInfographicGridData,
  IAddInfographicRowAndColumnAction,
  IFetchInfographicsDashBoardDataByIdAction,
  IInfographicsWidgetDataServer,
  IInfographicsDashboardDataServer,
  IUpdateInfographicsDashBoardDataByIdAction,
  IInfographicsDashboardDataClient,
  IUpdateInfographicsDashBoardDataByIdActionPayload,
  IAddInfographicsDashBoardDataByIdAction,
  IAddInfographicsDashBoardDataByIdActionPayload,
  IDeleteInfographicsDashBoardDataByFormIdAction,
  IFetchInfographicsDataByQueryAction,
  IInfographicDataByQueryPayload,
  IAddFormAnalyticPayload,
  IAddFormAnalyticAction,
  IActiveInfographicAnalytics,
  IGetFormAnalyticAction,
  IgetSubmissionCountAction,
  ISubmissionCount,
  IFetchOptionsForLookupFieldAction,
  IFetchOptionsForLookupFieldActionPayload,
  IFetchPermissionByIdAction,
  ICustomPermission,
  IFetchWorkflowAction,
  IFetchFormsByIdsFreeAction,
  IFetchFormsByIdsFreeActionPayload,
  IFetchOptionsForLookupFieldWithFilterAction,
  IFetchOptionsForLookupFieldWithFilterActionPayload,
} from "@common/redux/forms/interface";
import { IWorkflowServer } from "../formSubmission/interface";

const actionTypePrefix = "FORMS/";

export const formsActions = {
  ADD_NEW_FORM: `${actionTypePrefix}ADD_NEW_FORM`,
  REMOVE_FORM_BY_ID: `${actionTypePrefix}REMOVE_FORM_BY_ID`,
  ADD_NEW_FORM_SUCCESS: `${actionTypePrefix}ADD_NEW_FORM_SUCCESS`,

  ADD_NEW_FORM_FAILED: `${actionTypePrefix}ADD_NEW_FORM_FAILED`,

  UPDATE_FORM: `${actionTypePrefix}UPDATE_FORM`,

  UPDATE_FORM_SUCCESS: `${actionTypePrefix}UPDATE_FORM_SUCCESS`,

  UPDATE_FORM_FAILED: `${actionTypePrefix}UPDATE_FORM_FAILED`,

  TRANSFORM_AND_UPDATE_FORM: `${actionTypePrefix}TRANSFORM_AND_UPDATE_FORM`,

  TRANSFORM_AND_UPDATE_FORM_SUCCESS: `${actionTypePrefix}TRANSFORM_AND_UPDATE_FORM_SUCCESS`,

  TRANSFORM_AND_UPDATE_FORM_FAILED: `${actionTypePrefix}TRANSFORM_AND_UPDATE_FORM_FAILED`,

  DELETE_FORM: `${actionTypePrefix}DELETE_FORM`,

  DELETE_FORM_SUCCESS: `${actionTypePrefix}DELETE_FORM_SUCCESS`,

  DELETE_FORM_FAILED: `${actionTypePrefix}DELETE_FORM_FAILED`,

  FETCH_FORMS: `${actionTypePrefix}FETCH_FORMS`,

  FETCH_FORMS_SUCCESS: `${actionTypePrefix}FETCH_FORMS_SUCCESS`,

  FETCH_FORMS_FAILED: `${actionTypePrefix}FETCH_FORMS_FAILED`,

  SET_ACTIVE_FORM_ID: `${actionTypePrefix}SET_ACTIVE_FORM_ID`,

  FETCH_FORM_BY_IDS: `${actionTypePrefix}FETCH_FORM_BY_IDS`,

  FETCH_FORM_BY_IDS_SUCCESS: `${actionTypePrefix}FETCH_FORM_BY_IDS_SUCCESS`,

  FETCH_FORM_BY_IDS_FAILED: `${actionTypePrefix}FETCH_FORM_BY_IDS_FAILED`,

  FETCH_FORM_BY_IDS_FREE: `${actionTypePrefix}FETCH_FORM_BY_IDS_FREE`,

  DUPLICATE_FORM: `${actionTypePrefix}DUPLICATE_FORM`,

  DUPLICATE_FORM_SUCCESS: `${actionTypePrefix}DUPLICATE_FORM_SUCCESS`,

  DUPLICATE_FORM_FAILURE: `${actionTypePrefix}DUPLICATE_FORM_FAILURE`,

  CREATE_FORM_RULES: `${actionTypePrefix}CREATE_FORM_RULES`,

  CREATE_FORM_RULES_SUCCESS: `${actionTypePrefix}CREATE_FORM_RULES_SUCCESS`,

  CREATE_FORM_RULES_FAILURE: `${actionTypePrefix}CREATE_FORM_RULES_FAILURE`,
  FETCH_FORM_RULES: `${actionTypePrefix}FETCH_FORM_RULES`,

  FETCH_FORM_RULES_SUCCESS: `${actionTypePrefix}FETCH_FORM_RULES_SUCCESS`,

  FETCH_FORM_RULES_FAILURE: `${actionTypePrefix}FETCH_FORM_RULES_FAILURE`,

  UPDATE_FORM_RULES: `${actionTypePrefix}UPDATE_FORM_RULES`,

  UPDATE_FORM_RULES_SUCCESS: `${actionTypePrefix}UPDATE_FORM_RULES_SUCCESS`,

  UPDATE_FORM_RULES_FAILURE: `${actionTypePrefix}UPDATE_FORM_RULES_FAILURE`,

  DELETE_FORM_RULES: `${actionTypePrefix}DELETE_FORM_RULES`,

  DELETE_FORM_RULES_SUCCESS: `${actionTypePrefix}DELETE_FORM_RULES_SUCCESS`,

  DELETE_FORM_RULES_FAILURE: `${actionTypePrefix}DELETE_FORM_RULES_FAILURE`,

  RESET_FORM_RULES: `${actionTypePrefix}RESET_FORM_RULES`,

  ADD_INFOGRAFIC_ROW_COLUMN: `${actionTypePrefix}ADD_INFOGRAFIC_ROW_COLUMN`,

  FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID: `${actionTypePrefix}FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID`,
  FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS: `${actionTypePrefix}FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS`,
  FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE: `${actionTypePrefix}FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE`,

  UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID: `${actionTypePrefix}UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID`,
  UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS: `${actionTypePrefix}UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS`,
  UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE: `${actionTypePrefix}UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE`,

  ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID: `${actionTypePrefix}ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID`,
  ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS: `${actionTypePrefix}ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS`,
  ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE: `${actionTypePrefix}ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE`,

  UPDATE_WIDGET_DATA: `${actionTypePrefix}UPDATE_WIDGET_DATA`,

  DELETE_INFOGRAPHICS_DASHBOARD_DATA_BY_FORMID: `${actionTypePrefix} `,
  DELETE_INFOGRAPHICS_DASHBOARD_DATA_BY_FORMID_SUCCESS: `${actionTypePrefix}DELETE_INFOGRAPHICS_DASHBOARD_DATA_BY_FORMID_SUCCESS`,
  DELETE_INFOGRAPHICS_DASHBOARD_DATA_BY_FORMID_FAILURE: `${actionTypePrefix}DELETE_INFOGRAPHICS_DASHBOARD_DATA_BY_FORMID_FAILURE`,

  GET_INFOGRAPHIC_DATA_BY_QUERY: `${actionTypePrefix} GET_INFOGRAPHIC_DATA_BY_QUERY `,
  GET_INFOGRAPHIC_DATA_BY_QUERY_SUCCESS: `${actionTypePrefix} GET_INFOGRAPHIC_DATA_BY_QUERY_SUCCESS`,
  GET_INFOGRAPHIC_DATA_BY_QUERY_FAILURE: `${actionTypePrefix} GET_INFOGRAPHIC_DATA_BY_QUERY_FAILURE`,
  ADD_FORM_ANALYTICS: `${actionTypePrefix}ADD_FORM_ANALYTICS`,
  ADD_FORM_ANALYTICS_SUCCESS: `${actionTypePrefix}ADD_FORM_ANALYTICS_SUCCESS`,
  ADD_FORM_ANALYTICS_FAILURE: `${actionTypePrefix}ADD_FORM_ANALYTICS_FAILURE`,

  GET_FORM_ANALYTICS: `${actionTypePrefix}GET_FORM_ANALYTICS`,
  GET_FORM_ANALYTICS_SUCCESS: `${actionTypePrefix}GET_FORM_ANALYTICS_SUCCESS`,
  GET_FORM_ANALYTICS_FAILURE: `${actionTypePrefix}GET_FORM_ANALYTICS_FAILURE`,

  GET_FORM_SUBMISSION_COUNT: `${actionTypePrefix}GET_FORM_SUBMISSION_COUNT`,
  GET_FORM_SUBMISSION_COUNT_SUCCESS: `${actionTypePrefix}GET_FORM_SUBMISSION_COUNT_SUCCESS`,
  GET_FORM_SUBMISSION_COUNT_FAILURE: `${actionTypePrefix}GET_FORM_SUBMISSION_COUNT_FAILURE`,

  FETCH_OPTIONS_FOR_LOOKUP_FIELD: `${actionTypePrefix}FETCH_OPTIONS_FOR_LOOKUP_FIELD`,
  FETCH_OPTIONS_FOR_LOOKUP_FIELD_WITH_FILTER: `${actionTypePrefix}FETCH_OPTIONS_FOR_LOOKUP_FIELD_WITH_FILTER`,
  FETCH_PERMISSION_BY_ID: `${actionTypePrefix}FETCH_PERMISSION_BY_IDS`,
  FETCH_PERMISSION_BY_ID_SUCCESS: `${actionTypePrefix}FETCH_PERMISSION_BY_IDS_SUCCESS`,
  FETCH_PERMISSION_BY_ID_FAILED: `${actionTypePrefix}FETCH_PERMISSION_BY_IDS_FAILED`,

  FETCH_WORKFLOW: `${actionTypePrefix}FETCH_WORKFLOW`,
  FETCH_WORKFLOW_SUCCESS: `${actionTypePrefix}FETCH_WORKFLOW_SUCCESS`,
  FETCH_WORKFLOW_FAILURE: `${actionTypePrefix}FETCH_WORKFLOW_FAILURE`,
  FETCH_OPTIONS_FOR_LOOKUP_FIELD_WITH_FILTER_PUBLIC_API: `${actionTypePrefix}FETCH_OPTIONS_FOR_LOOKUP_FIELD_WITH_FILTER_PUBLIC_API`,

  CREATE_FORM_USING_TEMPLATE: `${actionTypePrefix}CREATE_FORM_USING_TEMPLATE`,
};
export const resetFormByIdAction = (payload: { formId: string }) => {
  return { type: formsActions.REMOVE_FORM_BY_ID, payload: payload };
};
export const addNewFormAction = (
  newForm: IAddNewFormActionPayload
): IAddNewFormAction => {
  return {
    type: formsActions.ADD_NEW_FORM,
    payload: newForm,
  };
};

export const addNewFormSuccessAction = (formData: IFormServer) => {
  return {
    type: formsActions.ADD_NEW_FORM_SUCCESS,
    payload: {
      formData,
    },
  };
};

export const addNewFormFailedAction = (error: string) => {
  return {
    type: formsActions.ADD_NEW_FORM_FAILED,
    payload: {
      error,
    },
  };
};

export const updateFormAction = (formData: IFormServer): IUpdateFormAction => {
  return {
    type: formsActions.UPDATE_FORM,
    payload: formData,
  };
};

export const updateFormSuccessAction = (formData: IFormServer) => {
  return {
    type: formsActions.UPDATE_FORM_SUCCESS,
    payload: {
      formData,
    },
  };
};

export const updateFormFailedAction = (error: string) => {
  return {
    type: formsActions.UPDATE_FORM_FAILED,
    payload: {
      error,
    },
  };
};

export const transformAndUpdateFormAction = (
  formData: IForm
): ITransformAndUpdateFormAction => {
  return {
    type: formsActions.TRANSFORM_AND_UPDATE_FORM,
    payload: formData,
  };
};

export const transformAndUpdateFormSuccessAction = (formData: IFormServer) => {
  return {
    type: formsActions.TRANSFORM_AND_UPDATE_FORM_SUCCESS,
    payload: {
      formData,
    },
  };
};

export const transformAndUpdateFormFailedAction = (error: string) => {
  return {
    type: formsActions.TRANSFORM_AND_UPDATE_FORM_FAILED,
    payload: {
      error,
    },
  };
};

export const deleteFormAction = (formIndex: number) => {
  return {
    type: formsActions.DELETE_FORM,
    payload: {
      formIndex,
    },
  };
};

export const deleteFormSuccessAction = (index: number) => {
  return {
    type: formsActions.DELETE_FORM_SUCCESS,
    payload: {
      index,
    },
  };
};

export const deleteFormFailedAction = (error: string) => {
  return {
    type: formsActions.DELETE_FORM_FAILED,
    payload: {
      error,
    },
  };
};

export const deleteFormRulesAction = (
  deleteFormRulePayload: IDeleteFormRulesActionPayload
): IDeleteFormRulesAction => {
  return {
    type: formsActions.DELETE_FORM_RULES,
    payload: deleteFormRulePayload,
  };
};

export const deleteFormRulesSuccessAction = (formId: string) => {
  return {
    type: formsActions.DELETE_FORM_RULES_SUCCESS,
    payload: {
      formId,
    },
  };
};

export const resetFormRules = () => {
  return {
    type: formsActions.RESET_FORM_RULES,
  };
};

export const deleteFormRulesFailedAction = (error: string) => {
  return {
    type: formsActions.DELETE_FORM_RULES_FAILURE,
    payload: {
      error,
    },
  };
};

export const fetchFormsAction = (
  payload: IFetchFormsActionPayload
): IFetchFormsAction => {
  return {
    type: formsActions.FETCH_FORMS,
    payload,
  };
};

export const fetchFormsSuccessAction = (
  fetchFormsApiResponse: IFetchFormsSuccessActionPayload
) => {
  return {
    type: formsActions.FETCH_FORMS_SUCCESS,
    payload: fetchFormsApiResponse,
  };
};

export const fetchFormsFailedAction = (payload: {
  error: string;
  pageNumber: number;
}) => {
  return {
    type: formsActions.FETCH_FORMS_FAILED,
    payload: payload,
  };
};

export const fetchFormRulesAction = (formId: string): IFetchFormRulesAction => {
  return {
    type: formsActions.FETCH_FORM_RULES,
    payload: {
      formId,
    },
  };
};

export const fetchFormRulesSuccessAction = (
  fetchFormRulesApiResponse: IAdvancedRulesClient
) => {
  return {
    type: formsActions.FETCH_FORM_RULES_SUCCESS,
    payload: fetchFormRulesApiResponse,
  };
};

export const fetchFormRulesFailureAction = (error: string) => {
  return {
    type: formsActions.FETCH_FORM_RULES_FAILURE,
    payload: {
      error,
    },
  };
};

export const updateFormRuleAction = (
  formRuleData: IAdvancedRulesClient
): IUpdateFormRuleAction => {
  return {
    type: formsActions.UPDATE_FORM_RULES,
    payload: formRuleData,
  };
};

export const updateFormRuleSuccessAction = (
  formRuleData: IAdvancedRulesServer
) => {
  return {
    type: formsActions.UPDATE_FORM_RULES_SUCCESS,
    payload: {
      formRuleData,
    },
  };
};

export const updateFormRuleFailedAction = (error: string) => {
  return {
    type: formsActions.UPDATE_FORM_RULES_FAILURE,
    payload: {
      error,
    },
  };
};

export const setActiveFormIdAction = (formId: string) => {
  return {
    type: formsActions.SET_ACTIVE_FORM_ID,
    payload: {
      formId: formId,
    },
  };
};

export const fetchFormsByIdsAction = (
  formIds: string[],
  isCurrentForm?: boolean
): IFetchFormsByIdsAction => {
  return {
    type: formsActions.FETCH_FORM_BY_IDS,
    payload: { formIds, isCurrentForm },
  };
};

export const fetchFormsByIdsFreeAction = (
  payload: IFetchFormsByIdsFreeActionPayload
): IFetchFormsByIdsFreeAction => {
  return {
    type: formsActions.FETCH_FORM_BY_IDS_FREE,
    payload,
  };
};

export const fetchFormsByIdsSuccessAction = (formDataServer: IFormServer[]) => {
  return {
    type: formsActions.FETCH_FORM_BY_IDS_SUCCESS,
    payload: formDataServer,
  };
};

export const fetchFormsByIdsFailedAction = (error: string) => {
  return {
    type: formsActions.FETCH_FORM_BY_IDS_FAILED,
    payload: {
      error,
    },
  };
};

export const duplicateFormAction = (formId: string): IDuplicateFormAction => {
  return {
    type: formsActions.DUPLICATE_FORM,
    payload: {
      formId,
    },
  };
};

export const duplicateFormSuccessAction = (
  formData: IFormServer
): IDuplicateFormSuccessAction => {
  return {
    type: formsActions.DUPLICATE_FORM_SUCCESS,
    payload: {
      formData,
    },
  };
};

export const duplicateFormFailureAction = (
  error: string
): IDuplicateFormFailureAction => {
  return {
    type: formsActions.DUPLICATE_FORM_FAILURE,
    payload: {
      error,
    },
  };
};

export const createFormRuleAction = (
  formRuleData: IAdvancedRulesClient
): IUpdateFormRuleAction => {
  return {
    type: formsActions.CREATE_FORM_RULES,
    payload: formRuleData,
  };
};

export const createFormRuleSuccessAction = (
  formRuleData: IAdvancedRulesServer
) => {
  return {
    type: formsActions.CREATE_FORM_RULES_SUCCESS,
    payload: {
      formRuleData,
    },
  };
};

export const createFormRuleFailureAction = (error: string) => {
  return {
    type: formsActions.CREATE_FORM_RULES_FAILURE,
    payload: {
      error,
    },
  };
};

export const addInforgraphicRowAndColumn = (
  gridData: IInfographicGridData
): IAddInfographicRowAndColumnAction => {
  return {
    type: formsActions.ADD_INFOGRAFIC_ROW_COLUMN,
    payload: gridData,
  };
};

export const fetchInfographicsDashBoardDataByIdAction = (
  formId: string
): IFetchInfographicsDashBoardDataByIdAction => {
  return {
    type: formsActions.FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID,
    payload: formId,
  };
};

export const fetchInfographicsDashBoardDataByIdSuccessAction = (
  formDashboardDataServer: IInfographicsDashboardDataClient
) => {
  return {
    type: formsActions.FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS,
    payload: formDashboardDataServer,
  };
};

export const fetchInfographicsDashBoardDataByIdFailureAction = (
  error: string
) => {
  return {
    type: formsActions.FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE,
    payload: {
      error,
    },
  };
};

export const updateInfographicsDashBoardDataByIdAction = (
  payload: IUpdateInfographicsDashBoardDataByIdActionPayload
): IUpdateInfographicsDashBoardDataByIdAction => {
  return {
    type: formsActions.UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID,
    payload: payload,
  };
};

export const updateInfographicsDashBoardDataByIdSuccessAction = (
  formDashboardDataServer: IInfographicsDashboardDataServer
) => {
  return {
    type: formsActions.UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS,
    payload: formDashboardDataServer,
  };
};

export const updateInfographicsDashBoardDataByIdFailureAction = (
  error: string
) => {
  return {
    type: formsActions.UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE,
    payload: {
      error,
    },
  };
};

export const updateWidgetDataAction = (
  formId: string,
  widgetData: IInfographicsWidgetDataServer
) => {
  return {
    type: formsActions.UPDATE_WIDGET_DATA,
    payload: {
      formId,
      widgetData,
    },
  };
};

export const addInfographicsDashBoardDataByIdAction = (
  payload: IAddInfographicsDashBoardDataByIdActionPayload
): IAddInfographicsDashBoardDataByIdAction => {
  return {
    type: formsActions.ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID,
    payload: payload,
  };
};

export const addInfographicsDashBoardDataByIdSuccessAction = (
  formDashboardDataServer: IInfographicsDashboardDataServer
) => {
  return {
    type: formsActions.ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS,
    payload: formDashboardDataServer,
  };
};

export const addInfographicsDashBoardDataByIdFailureAction = (
  error: string
) => {
  return {
    type: formsActions.ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE,
    payload: {
      error,
    },
  };
};

export const deleteInfographicsDashBoardDataByFormIdAction = (
  formId: string
): IDeleteInfographicsDashBoardDataByFormIdAction => {
  return {
    type: formsActions.DELETE_INFOGRAPHICS_DASHBOARD_DATA_BY_FORMID,
    payload: formId,
  };
};

export const deleteInfographicsDashBoardDataByFormIdSuccessAction = (
  formId: string
): IDeleteInfographicsDashBoardDataByFormIdAction => {
  return {
    type: formsActions.DELETE_INFOGRAPHICS_DASHBOARD_DATA_BY_FORMID_SUCCESS,
    payload: formId,
  };
};

export const deleteInfographicsDashBoardDataByFormIdFailureAction = (
  error: string
) => {
  return {
    type: formsActions.DELETE_INFOGRAPHICS_DASHBOARD_DATA_BY_FORMID_FAILURE,
    payload: {
      error,
    },
  };
};

export const addFormAnalytics = (
  payload: IAddFormAnalyticPayload
): IAddFormAnalyticAction => {
  return {
    type: formsActions.ADD_FORM_ANALYTICS,
    payload: payload,
  };
};

export const addFormAnalyticsSuccess = () => {
  return {
    type: formsActions.ADD_FORM_ANALYTICS_SUCCESS,
  };
};

export const addFormAnalyticsFailure = (error: string) => {
  return {
    type: formsActions.ADD_FORM_ANALYTICS_FAILURE,
    payload: error,
  };
};
export const getFormAnalytics = (formId: string): IGetFormAnalyticAction => {
  return {
    type: formsActions.GET_FORM_ANALYTICS,
    payload: formId,
  };
};

export const getFormAnalyticsSuccess = (data: IActiveInfographicAnalytics) => {
  return {
    type: formsActions.GET_FORM_ANALYTICS_SUCCESS,
    payload: data,
  };
};
export const getFormAnalyticsFailure = (error: string) => {
  return {
    type: formsActions.GET_FORM_ANALYTICS_FAILURE,
    payload: error,
  };
};
export const getInfographicsDataByQueryAction = (
  payload: IInfographicDataByQueryPayload
): IFetchInfographicsDataByQueryAction => {
  return {
    type: formsActions.GET_INFOGRAPHIC_DATA_BY_QUERY,
    payload: payload,
  };
};
export const getInfographicsDataByQuerySuccessAction = (data: any) => {
  return {
    type: formsActions.GET_INFOGRAPHIC_DATA_BY_QUERY_SUCCESS,
    payload: data,
  };
};
export const getInfographicsDataByQueryFailureAction = (error: string) => {
  return {
    type: formsActions.GET_INFOGRAPHIC_DATA_BY_QUERY_FAILURE,
    payload: {
      error,
    },
  };
};

export const getSubmissionCountAction = (
  formIds: string[]
): IgetSubmissionCountAction => {
  return {
    type: formsActions.GET_FORM_SUBMISSION_COUNT,
    payload: formIds,
  };
};

export const getSuibmissionCountSuccessAction = (
  submissionCounts: ISubmissionCount[]
) => {
  return {
    type: formsActions.GET_FORM_SUBMISSION_COUNT_SUCCESS,
    payload: {
      submissionCounts,
    },
  };
};

export const getSuibmissionCountFailureAction = (error: string) => {
  return {
    type: formsActions.GET_FORM_SUBMISSION_COUNT_FAILURE,
    payload: {
      error,
    },
  };
};

export const fetchOptionsForLookupFieldAction = (
  payload: IFetchOptionsForLookupFieldActionPayload
): IFetchOptionsForLookupFieldAction => {
  return {
    type: formsActions.FETCH_OPTIONS_FOR_LOOKUP_FIELD,
    payload,
  };
};

export const fetchOptionsForLookupFieldWithFilterAction = (
  payload: IFetchOptionsForLookupFieldWithFilterActionPayload
): IFetchOptionsForLookupFieldWithFilterAction => {
  return {
    type: formsActions.FETCH_OPTIONS_FOR_LOOKUP_FIELD_WITH_FILTER,
    payload,
  };
};

export const fetchOptionsForLookupFieldWithFilterActionPublicApi = (
  payload: IFetchOptionsForLookupFieldWithFilterActionPayload
): IFetchOptionsForLookupFieldWithFilterAction => {
  return {
    type: formsActions.FETCH_OPTIONS_FOR_LOOKUP_FIELD_WITH_FILTER_PUBLIC_API,
    payload,
  };
};

export const fetchPermissionsByIdAction = (
  id: string,
  roleName?:string
): IFetchPermissionByIdAction => {
  return {
    type: formsActions.FETCH_PERMISSION_BY_ID,
    payload: id,
    roleName,
  };
};

export const fetchPermissionsByIdSuccessAction = (
  formDataServer: ICustomPermission
) => {
  return {
    type: formsActions.FETCH_PERMISSION_BY_ID_SUCCESS,
    payload: formDataServer,
  };
};

export const fetchPermissionsByIdFailedAction = (error: string) => {
  return {
    type: formsActions.FETCH_PERMISSION_BY_ID_FAILED,
    payload: {
      error,
    },
  };
};

export const fetchWorkflowByFormIdAction = (
  formId: string
): IFetchWorkflowAction => {
  return {
    type: formsActions.FETCH_WORKFLOW,
    payload: {
      formId,
    },
  };
};

export const fetchWorkflowSuccessAction = (payload: IWorkflowServer[]) => {
  return {
    type: formsActions.FETCH_WORKFLOW_SUCCESS,
    payload,
  };
};

export const fetchWorkflowFailureAction = (error: string) => {
  return {
    type: formsActions.FETCH_WORKFLOW_FAILURE,
    payload: {
      error,
    },
  };
};

export const createFormUsingTemplateAction = (
  newForm: IAddNewFormActionPayload
): IAddNewFormAction => {
  return {
    type: formsActions.CREATE_FORM_USING_TEMPLATE,
    payload: newForm,
  };
};
